import React, { useState } from "react";
import "../../../../../assets/styles/common/modal.scss";

import { formatTodayDate } from "../../../../../utils/judgingSheetUtils";
import JudgingSheetTemplateShortForm, {
  SHEET_WIDTH_SHORT_FORM,
  SHEET_HEIGHT_SHORT_FORM,
} from "./JudgingSheetTemplateShortForm";

import musicalityShortImg from "../../../../../assets/images/judgingSheet/Musicality_Judging_short_Form.png";
import performanceShortImg from "../../../../../assets/images/judgingSheet/Performance_Judging_short_Form.png";
import singingShortImg from "../../../../../assets/images/judgingSheet/Singing_Judging_short_Form.png";

const CATEGORY_IMAGES = [
  musicalityShortImg,
  performanceShortImg,
  singingShortImg,
];

const SAMPLE_ENTRY_CLASS_LABEL = "Entry Class";
const SAMPLE_TOP_GROUP_NAME = "Group Name 1";
const SAMPLE_BOTTOM_GROUP_NAME = "Group Name 2";
const SAMPLE_JUDGE_NAME = "Judge Name";
const SAMPLE_TOP_NUMBER = 1;
const SAMPLE_BOTTOM_NUMBER = 2;

// 画面に収まるよう、実寸(1836x2376px)を縮小して表示する倍率
const PREVIEW_SCALE = 0.25;

const JudgingSheetPreviewButtonShortForm: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const dateStr = formatTodayDate();

  return (
    <>
      <button
        type="button"
        className="download-btn judging-sheet-download-btn"
        onClick={() => setIsOpen(true)}
        title="Short Formレイアウト確認用のサンプルをモーダルで表示"
      >
        見た目を確認
      </button>

      {isOpen && (
        <div className="modal-overlay" onClick={() => setIsOpen(false)}>
          <div
            className="modal-container judging-sheet-preview-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="modal-title">採点用紙（Short Form） 見た目確認</h2>

            <div className="judging-sheet-preview-panel">
              {CATEGORY_IMAGES.map((image) => (
                <div
                  className="judging-sheet-preview-frame"
                  key={image}
                  style={{
                    width: SHEET_WIDTH_SHORT_FORM * PREVIEW_SCALE,
                    height: SHEET_HEIGHT_SHORT_FORM * PREVIEW_SCALE,
                  }}
                >
                  <div
                    style={{
                      transform: `scale(${PREVIEW_SCALE})`,
                      transformOrigin: "top left",
                    }}
                  >
                    <JudgingSheetTemplateShortForm
                      imageSrc={image}
                      entryClassLabel={SAMPLE_ENTRY_CLASS_LABEL}
                      dateStr={dateStr}
                      judgeName={SAMPLE_JUDGE_NAME}
                      judgeNumber={1}
                      topEntryNumber={SAMPLE_TOP_NUMBER}
                      topGroupName={SAMPLE_TOP_GROUP_NAME}
                      bottomEntryNumber={SAMPLE_BOTTOM_NUMBER}
                      bottomGroupName={SAMPLE_BOTTOM_GROUP_NAME}
                    />
                  </div>
                </div>
              ))}
            </div>

            <div className="modal-actions">
              <button
                type="button"
                className="cancel-button"
                onClick={() => setIsOpen(false)}
              >
                閉じる
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default JudgingSheetPreviewButtonShortForm;
